import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import moment from 'moment';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import SignedRoutes from './SignedRoutes';
import GuestRoutes from './GuestRoutes';

import LoadingScreen from '../../screens/LoadingScreen';

import MainLayout from '../../layouts/MainLayout';
import AuthorizationLayout from '../../layouts/AuthorizationLayout';

import OnboardingLayout from '../../layouts/OnboardingLayout/OnboardingLayout';
import { userSelector } from '../../redux/selectors/Account';

const Routes = () => {
  const location = useLocation();
  const isOnboard = location.pathname.split('/').includes('onboard');
  const isSSO = location.pathname.split('/').includes('sso');


  const user = useSelector(userSelector);

  return (
    <Suspense fallback={<LoadingScreen />}>
      {process?.env?.BUILT_AT && (
        <Box
          display='flex'
          justifyContent='center'
          color='#fff'
          className={`env-bar bar-style-${window?.env?.ENV_MODE}`}
          height={25}
        >
          <Typography variant='h6'>Environment:&nbsp;</Typography>
          <Typography variant='h6' style={{ textTransform: 'capitalize' }}>
            {window?.env?.ENV_MODE}
          </Typography>
          {process?.env?.BRANCH && (
          <>
            <Typography variant='h6'>&nbsp;||&nbsp;</Typography>
            <Typography variant='h6'>Branch:&nbsp;</Typography>
            <Typography variant='h6'>{process?.env?.BRANCH}</Typography>
          </>
          )}
          <Typography variant='h6'>&nbsp;||&nbsp;</Typography>
          <Typography variant='h6'>Built at:&nbsp;</Typography>
          <Typography variant='h6'>{moment(process.env.BUILT_AT).format('lll')}</Typography>
        </Box>
      )}

      {
      // eslint-disable-next-line no-nested-ternary
      user && !isSSO ? (
        <MainLayout>
          <Suspense fallback={<LoadingScreen />}>
            <SignedRoutes />
          </Suspense>
        </MainLayout>
      ) : isOnboard ? (
        <OnboardingLayout />
      ) : (
        <AuthorizationLayout>
          <Suspense fallback={<LoadingScreen />}>
            <GuestRoutes />
          </Suspense>
        </AuthorizationLayout>
      )
      }

    </Suspense>
  );
};

export default Routes;
